import { Fetch, FetchQueue } from "@sopheos/orbjs_fetch";

// current
window.useHttp = new Fetch(
    {
        credentials: "include",
    },
    {
        handleErrors: (e, { options }) => {
            if (options?.extra?.dialog) {
                return;
            }

            if (
                e.status === 401 ||
                (e.status === 403 && e.data.error === "user_state")
            ) {
                window.useSnackbar.add({
                    key: window.useSnackbar.LOGOUT,
                    type: window.useSnackbar.TYPE_ERROR,
                    message:
                        e.status === 401
                            ? "Vous avez été déconnecté du site."
                            : "Votre compte est bloqué car vous ne respectez pas les règles de agenda.org",
                    close: true,
                });
            } else if (e.status === 500) {
                window.useSnackbar.add({
                    key: window.useSnackbar.ERROR,
                    type: window.useSnackbar.TYPE_ERROR,
                    message:
                        e.data.error === "offline"
                            ? "Vous êtes hors ligne. Veuillez vous reconnecter et réessayer."
                            : "Nous avons rencontré une erreur. Veuillez réessayer ultérieurement.",
                    close: true,
                });
            }
        },
    },
);

// geo
window.useHttpGeo = new FetchQueue(
    {
        baseUrl: window.CONFIG.apiGeo,
    },
    {
        connected: true,
        generate: () => {
            return window.useHttp.get("/api/v1/token/geo").then(({ body }) => {
                const timestamp = Date.now();
                window.useHttpGeo.accessStore = {
                    token: body.accessToken,
                    delay: body.expireIn * 1000,
                    exp: timestamp + body.expireIn * 1000,
                };
            });
        },
        handleErrors: (e, { options }) => {
            if (e.status === 500 && !options?.extra?.dialog) {
                window.useSnackbar.add({
                    key: window.useSnackbar.ERROR,
                    type: window.useSnackbar.TYPE_ERROR,
                    message:
                        e.data.error === "offline"
                            ? "Vous êtes hors ligne. Veuillez vous reconnecter et réessayer."
                            : "Nous avons rencontré une erreur. Veuillez réessayer ultérieurement.",
                    close: true,
                });
            }
        },
    },
);

class ApiFetchQueue extends FetchQueue {
    send(url, options = {}) {
        options.headers = {
            "X-Agenda-Client": window.CONFIG.apiClient,
            ...options.headers,
        };
        return super.send(url, options);
    }
}

// api
window.useHttpApi = new ApiFetchQueue(
    {
        baseUrl: window.CONFIG.apiUrl,
    },
    {
        connected: window.CONFIG.connected,
        generate: () => {
            return window.useHttp.get("/api/v1/token/api").then(({ body }) => {
                const timestamp = Date.now();
                window.useHttpApi.accessStore = {
                    token: body.accessToken,
                    delay: body.expireIn * 1000,
                    exp: timestamp + body.expireIn * 1000,
                };
            });
        },
        handleErrors: (e, { options }) => {
            if (e.status === 500 && !options?.extra?.dialog) {
                window.useSnackbar.add({
                    key: window.useSnackbar.ERROR,
                    type: window.useSnackbar.TYPE_ERROR,
                    message:
                        e.data.error === "offline"
                            ? "Vous êtes hors ligne. Veuillez vous reconnecter et réessayer."
                            : "Nous avons rencontré une erreur. Veuillez réessayer ultérieurement.",
                    close: true,
                });
            }
        },
    },
);

// Pay
window.useHttpPay = new FetchQueue(
    {
        baseUrl: window.CONFIG.apiPay,
    },
    {
        connected: true,
        generate: () => {
            return window.useHttp.get("/api/v1/token/pay").then(({ body }) => {
                const timestamp = Date.now();
                window.useHttpPay.accessStore = {
                    token: body.accessToken,
                    delay: body.expireIn * 1000,
                    exp: timestamp + body.expireIn * 1000,
                };
            });
        },
        handleErrors: (e, { options }) => {
            if (e.status === 500 && !options?.extra?.dialog) {
                window.useSnackbar.add({
                    key: window.useSnackbar.ERROR,
                    type: window.useSnackbar.TYPE_ERROR,
                    message:
                        e.data.error === "offline"
                            ? "Vous êtes hors ligne. Veuillez vous reconnecter et réessayer."
                            : "Nous avons rencontré une erreur. Veuillez réessayer ultérieurement.",
                    close: true,
                });
            }
        },
    },
);
